export default "__VITE_ASSET__CnGXoULO__"